"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignsService = void 0;
class CampaignsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a list of campaigns.
     * @param page 'Page number (default 1)
     * @param count Number of results per page (default 10)
     * @param q Query to filter the results on
     * @returns CampaignsResponse
     * @throws ApiError
     */
    getCampaigns(page, count, q) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/campaigns',
            query: {
                'page': page,
                'count': count,
                'q': q,
            },
        });
    }
    /**
     * Create a campaign
     * @param requestBody
     * @returns CampaignResponse
     * @throws ApiError
     */
    createCampaign(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/campaigns',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Campaigns search (filter + sort)
     * @param sort
     * @param filter
     * @param page
     * @param count
     * @returns CampaignSearchResult
     * @throws ApiError
     */
    searchCampaigns(sort, filter, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/campaigns/search',
            query: {
                'sort': sort,
                'filter': filter,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Returns a specific campaign by id.
     * @param id
     * @returns CampaignResponse
     * @throws ApiError
     */
    getCampaign(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/campaigns/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a campaign
     * @param id
     * @param requestBody
     * @returns CampaignResponse
     * @throws ApiError
     */
    updateCampaign(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/campaigns/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a campaign
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteCampaign(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/campaigns/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Campaigns column information meta data
     * @returns SearchColumnsMetadata
     * @throws ApiError
     */
    getCampaignsSearchMetadata() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/campaigns/search/metadata',
        });
    }
    /**
     * Returns a specific campaign by id with metadata.
     * @param id
     * @returns CampaignMetadata
     * @throws ApiError
     */
    getCampaignMetadata(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/campaigns/{id}/metadata',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Duplicate a campaign
     * @param id
     * @param requestBody
     * @returns CampaignResponse
     * @throws ApiError
     */
    duplicateCampaign(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/campaigns/{id}/duplicate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * add deliverable to campaign
     * @param id
     * @param requestBody
     * @returns CampaignDeliverableParam
     * @throws ApiError
     */
    addCampaignDeliverable(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/campaigns/{id}/deliverable',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns available campaign label terms information
     * @param string
     * @param size
     * @returns SearchTermsResponse
     * @throws ApiError
     */
    getCampaignsLabelsTerms(string, size) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/campaigns/labels/terms',
            query: {
                'string': string,
                'size': size,
            },
        });
    }
    /**
     * Create a campaign budget
     * @param id
     * @param requestBody
     * @returns CampaignResponse
     * @throws ApiError
     */
    createCampaignBudget(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/campaigns/{id}/budgets',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update a campaign budget
     * @param campaignId
     * @param budgetId
     * @param requestBody
     * @returns CampaignResponse
     * @throws ApiError
     */
    updateCampaignBudget(campaignId, budgetId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/campaigns/{campaignId}/budgets/{budgetId}',
            path: {
                'campaignId': campaignId,
                'budgetId': budgetId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a campaign budget
     * @param campaignId
     * @param budgetId
     * @returns CampaignResponse
     * @throws ApiError
     */
    deleteCampaignBudget(campaignId, budgetId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/campaigns/{campaignId}/budgets/{budgetId}',
            path: {
                'campaignId': campaignId,
                'budgetId': budgetId,
            },
        });
    }
    /**
     * Recalculate all deployments in an entire campaign budget
     * @param campaignId
     * @param budgetId
     * @returns CampaignResponse
     * @throws ApiError
     */
    recalcCampaignBudget(campaignId, budgetId) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/campaigns/{campaignId}/budgets/{budgetId}/recalc-deployments',
            path: {
                'campaignId': campaignId,
                'budgetId': budgetId,
            },
        });
    }
    /**
     * Update a campaign revenue
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    updateCampaignRevenue(id) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/campaigns/{id}/recalc-revenue',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get campaign revenue(s)
     * @param id
     * @returns CampaignRevenueResponse
     * @throws ApiError
     */
    getCampaignRevenue(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/campaigns/{id}/revenues',
            path: {
                'id': id,
            },
        });
    }
}
exports.CampaignsService = CampaignsService;
